import { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [isJoinOpen, setIsJoinOpen] = useState(false);

  const openJoinModal = () => setIsJoinOpen(true);
  const closeJoinModal = () => setIsJoinOpen(false);

  return (
    <ModalContext.Provider
      value={{ isJoinOpen, openJoinModal, closeJoinModal }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => useContext(ModalContext);
